import { useParams } from "react-router-dom"
import { Webhook } from "@mui/icons-material"
import { useAppSelector } from "hooks/redux"
import HomeHeader from "modules/home-header"
import { getCurrentApplication } from "./selectors"

interface Props {
  account: string
}

export default function ApplicationHeader({ account }: Props) {
  const params = useParams()
  const application = useAppSelector(state => getCurrentApplication(state, { params }))

  return <HomeHeader
    account={account}
    Icon={Webhook}
    title={application ? `Application: ${application.name}` : "Application"}
  />
}
